import React, { JSX } from "react";
import {
  extractHiddenBlock,
  getBackgroundImageStyle,
  getBackgroundImageURL,
  normalizeStyles,
} from "../../../utils/styles";
import { AppPlaceholder } from "@sitecore-content-sdk/nextjs";
import { ContainerProps } from "components/sxa/container/container.props";
import componentMap from ".sitecore/component-map";
import Image from "next/image";

export const Default = (props: ContainerProps): JSX.Element => {
  console.log("---->[Container] Component");

  const { page, params, rendering } = props;

  const phKey = `container-${props?.params?.DynamicPlaceholderId}`;
  const id = props?.params?.RenderingIdentifier;
  const { isEditing, isPreview } = page.mode;
  const isNormalMode = !(isEditing || isPreview);
  const styles = normalizeStyles(params?.Styles);
  const bgImgUrl = getBackgroundImageURL(params?.BackgroundImage, isEditing);
  const backgroundStyle =
    !isNormalMode && bgImgUrl ? getBackgroundImageStyle(bgImgUrl) : {};
  const paddingPageBuilder = isEditing ? "p-5" : "p-0";
  const containerWidth =
    params?.Styles === "container-wide"
      ? "lg:max-w-(--sitewide-wide-container-max-width)"
      : "lg:max-w-(--sitewide-container-max-width)";
  const hiddenBlockStyles = extractHiddenBlock(props?.params?.GridParameters);

  return (
    <div
      className={`container-component mx-auto w-full ${containerWidth} relative flex flex-col ${paddingPageBuilder} ${styles} ${hiddenBlockStyles} ${bgImgUrl && isNormalMode ? "bg-transparent" : ""} ${bgImgUrl ? "container-with-image" : ""}`}
      id={id || undefined}
      style={backgroundStyle}
      data-role="container-component"
    >
      {bgImgUrl && isNormalMode && (
        <Image
          src={bgImgUrl}
          alt=""
          sizes="100vw"
          className="absolute top-0 bottom-0 left-0 right-0 object-cover object-center z-[-1]"
          fill
          loading="lazy"
        />
      )}
      <div className="componentContent">
        <AppPlaceholder
          name={phKey}
          rendering={rendering}
          page={page}
          componentMap={componentMap}
        />
      </div>
    </div>
  );
};
